import React from "react";
import { Modal } from "react-bootstrap";
import Form from "../Components/Comman/Form";
import Joi from "joi-browser";
import auth from "../Services/authService";
import { getAlert } from "../Services/appAlerts";

const CHANGE_PASSWORD_STYLES = {
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    paddingRight: "0"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "44px",
    height: "44px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "20px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "21px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    marginBottom: "10px"
  },
  helperList: {
    margin: 0,
    paddingLeft: "18px",
    color: "#475569",
    fontSize: "12px",
    lineHeight: 1.7
  },
  formCard: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    padding: "18px 18px 6px 18px"
  },
  modalFooter: {
    padding: "16px 22px 20px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800
  },
  saveButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)"
  },
  saveButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none"
  }
};

class ChangePassword extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
    };
  }

  schema = {
    oldPassword: Joi.string().required().label("Old Password"),
    newPassword: Joi.string().required().label("New Password"),
    //confirmPassword: Joi.string().required().label("Confirm Password"),
    confirmPassword: Joi.any()
      .valid(Joi.ref("newPassword"))
      .required()
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      const passResult = this.password_validate(data.confirmPassword);

      if (passResult) {
        const user = auth.getCurrentUser();
        await auth.changePassword(
          data.oldPassword,
          data.confirmPassword,
          user.id
        );
        getAlert("", "Password Changed Successfully", "success");
      } else {
        getAlert(
          "Password Strength",
          "Please enter strong password",
          "error"
        );
      }
    } catch (ex) {
      //console.log(ex);
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.oldPassword = ex.response.data.message;
        this.setState({ errors });
      }
    }
  };

  password_validate(password) {
    var re = {
      capital: /[A-Z]/,
      digit: /[0-9]/,
      except: /[aeiou]/,
      full: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?][A-Za-z0-9]/,
    };
    //console.log("capital", re.capital.test(password));
    //console.log("digit", re.digit.test(password));
    //console.log("except", re.except.test(password));
    //console.log("full", re.full.test(password));
    return (
      re.capital.test(password) &&
      re.digit.test(password) &&
      re.except.test(password) &&
      re.full.test(password)
    );
  }

  componentWillReceiveProps = () => {
    this.setState({ data: {}, errors: {} });
  };

  // getAlert(title, message, type) {
  //   return Swal.fire({
  //     title: title,
  //     text: message,
  //     icon: type,
  //     confirmButtonText: "Close",
  //     confirmButtonColor: "#d33",
  //     onClose: () => {
  //       if (type === "success") {
  //         //window.location = "/AdminLogin";
  //         auth.logout();
  //         window.location = "/Login";
  //       }
  //     },
  //   });
  // }

  render() {
    const { handleModalShowHide, showHide } = this.props;
    const isSaveDisabled = this.validate();
    return (
      <Modal show={showHide} size="lg" centered>
        <Modal.Header style={CHANGE_PASSWORD_STYLES.modalHeader}>
          <div style={CHANGE_PASSWORD_STYLES.headerContent}>
            <Modal.Title as="div" style={CHANGE_PASSWORD_STYLES.titleWrap}>
              <div style={CHANGE_PASSWORD_STYLES.headerIcon}>
                <i className="fa fa-lock" aria-hidden="true"></i>
              </div>
              <div>
                <div style={CHANGE_PASSWORD_STYLES.title}>Change Password</div>
                <div style={CHANGE_PASSWORD_STYLES.subtitle}>Create a stronger password to keep your account protected.</div>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={CHANGE_PASSWORD_STYLES.closeButton}
              onClick={handleModalShowHide}
              aria-label="Close change password"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={CHANGE_PASSWORD_STYLES.modalBody}>
          <div style={CHANGE_PASSWORD_STYLES.helperCard}>
            <div style={CHANGE_PASSWORD_STYLES.helperTitle}>Password requirements</div>
            <div style={CHANGE_PASSWORD_STYLES.helperText}>
              Use a password that is hard to guess and easy for you to remember.
            </div>
            <ul style={CHANGE_PASSWORD_STYLES.helperList}>
              <li>Use at least 8 characters and no spaces.</li>
              <li>Include uppercase letters and numbers.</li>
              <li>Include at least one special character such as `!`, `@`, `#`, or `?`.</li>
            </ul>
          </div>
          <div style={CHANGE_PASSWORD_STYLES.formCard}>
            <div className="row">
              <div className="col-md-12">
                {this.renderInput("oldPassword", "Old Password", "password")}
              </div>
              <div className="col-md-12">
                {this.renderInput("newPassword", "New Password", "password")}
              </div>
              <div className="col-md-12">
                {this.renderInput(
                  "confirmPassword",
                  "Confirm Password",
                  "password"
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={CHANGE_PASSWORD_STYLES.modalFooter}>
          <div style={CHANGE_PASSWORD_STYLES.footerActions}>
            <button
              type="button"
              style={CHANGE_PASSWORD_STYLES.cancelButton}
              onClick={handleModalShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Cancel
            </button>
            <button
              type="button"
              style={{
                ...CHANGE_PASSWORD_STYLES.saveButton,
                ...(isSaveDisabled ? CHANGE_PASSWORD_STYLES.saveButtonDisabled : {})
              }}
              disabled={isSaveDisabled}
              onClick={this.handleSubmit}
            >
              <i className="fa fa-check" aria-hidden="true"></i>
              Save Password
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ChangePassword;
